<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="6" md="6">
                <v-row 
                    v-for="(record, idx) in hrev_records"
                    :key="idx">
                    <v-col cols="3">
                        <v-text-field 
                            v-model="record.key"
                            label="Historical Year"
                            @change="updateRecords">
                        </v-text-field>
                    </v-col>
                    <v-col cols="1">
                    </v-col>
                    <v-col cols="4"> 
                        <v-text-field 
                            v-model="record.val"
                            label="Historical Value"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="updateRecords">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    import { 
        formatNumbers,
        scrubNumbers } from '../../helpers/utilities'

    export default {
        name: 'HistoricalRevenue',
        props: [
            'editData'
        ],
        data: () => ({
            hrev_records: []
        }),
        mounted () {
            this.createObject()
        },
        watch: {
            editData(val) {
                this.createObject()
            }
        },
        methods: {
            createObject: function () {
                this.hrev_records=[];
                // console.log('echo:', this.editData.revenue_historical)
                if ( this.editData.revenue_historical != undefined && Object.keys(this.editData.revenue_historical).length !== 0 ) {
                    for ( let [key, value] of Object.entries(this.editData.revenue_historical) ) {
                        if ( key != '' ) {
                            let val = value != null ? formatNumbers(value) : '';
                            this.hrev_records.push({ key, val })
                        } else {
                            let key='', val='';
                            this.hrev_records.unshift({ key, val })
                        }
                    }
                    //console.log(this.hrev_records)
                    this.hrev_records.reverse()
                    const empty_key='', empty_val=''
                    this.hrev_records.push({ empty_key, empty_val })
                } else {
                    // -- NEED THE "AS OF" DATE TO START THE YEAR TO MOVE BACKWARDS FROM ... MAYBE --
                    const thisYear = new Date().getFullYear();
                    for ( var i = 1; i < 7 ; i++ ) {
                        let key = (thisYear-i)
                        let val = ''
                        this.hrev_records.push({ key, val})
                    }
                }
                //console.log(this.hrev_records)
            },

            updateRecords: function () {
                let updated_values=[], updated_object={};
                for ( let val of this.hrev_records ) {
                    if (val.key !== '' && val.key !== undefined) {
                        updated_values.push(val)
                    }
                }
                updated_values.sort(function(a, b){return b.key - a.key});
                //console.log('updated_values: ',updated_values)

                for (var i = 0; i < updated_values.length; i++) {
                    updated_object[updated_values[i].key] = parseInt(scrubNumbers(updated_values[i].val));
                }
                //console.log('updated_object: ',updated_object)

                this.editData.revenue_historical = Object.assign({}, updated_object);
                //console.log('final: ', this.editData.revenue_historical)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/HistoricalRevenue.vue